import { defineStore } from 'pinia';
import { AxiosError } from 'axios';
import { getError } from '@/plugins';
import { useLoaderStore } from './loader';

interface IErrorState {
  name: string;
  message: string;
  debugInfo: string;
}

export const useErrorStore = defineStore('error', {
  state: (): IErrorState => ({
    name: '',
    message: '',
    debugInfo: '',
  }),

  getters: {
    error: (state) => state,
  },

  actions: {
    setError(e: AxiosError) {
      // Пропускаем при разлогинивание пользователя
      if (e.response?.status === 401 || e.response?.status === 423) {
        return;
      }

      const loaderStore = useLoaderStore();
      loaderStore.setLoader(); // Если был лоадер, а возникла ошибка, к ней не попасть

      const { message = '', config, response, code, status } = e;
      let { name = '' } = e;
      let _errorMessage = `${name} ${message}`;
      name = name === 'AxiosError' ? 'Ошибка сервера' : 'Ошибка клиента';

      if (response) {
        if (status === 501 || status === 502) {
          name = 'Сервер временно недоступен, зайдите позже';
          _errorMessage = '';
        } else {
          _errorMessage = getError(response);
        }
      }

      this.name = name;
      this.message = _errorMessage;

      const isDebug = true;

      if (isDebug) {
        const params = config?.data && config.data.length < 500 ? '\n' + config.data : undefined;
        this.debugInfo = [status, config?.method, config?.url, code, params].filter((r) => r).join(' ');
      }
    },

    clearError() {
      this.name = '';
      this.message = '';
      this.debugInfo = '';
    },
  },
});

export default useErrorStore;
